import { useRef } from 'react';

import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Section } from '@/src/components/organisms';
import { scroller } from '@/src/lib/utils';

import { About, Advantages } from './components';
import { advantages } from './data';

const useStyles = makeStyles(theme => ({
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },

  footerNewsletterSection: {
    background: `${theme.palette.primary.dark} !important`,
  },
}));

const SecurityView = () => {
  const classes = useStyles();
  const advantagesRef = useRef();

  const scrollToRef = ref => setTimeout(() => scroller(ref.current.offsetTop - 200), 500);

  return (
    <div>
      <Section className={classes.pagePaddingTop}>
        <>
          <About onLearnMore={() => scrollToRef(advantagesRef)} />
          <Section>
            <Divider />
          </Section>
          <div ref={advantagesRef}>
            <Advantages data={advantages} />
          </div>
        </>
      </Section>
    </div>
  );
};

export default SecurityView;
